
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";

export default class HelpIcon extends Vue {
  @Prop({ type: String }) width = 24;
  @Prop({ type: String }) height = 24;
  @Prop({ type: String, required: true }) tooltipText!: string;
  @Prop({ type: String }) position:
    | "top"
    | "top-left"
    | "top-right"
    | "bottom"
    | "bottom-left"
    | "bottom-right"
    | "left"
    | "right" = "left";
  @Prop({ type: String }) cls: string = "uk-active";
}
